import { render, staticRenderFns } from "./Blogp.vue?vue&type=template&id=3f7f1986&"
import script from "./Blogp.vue?vue&type=script&lang=js&"
export * from "./Blogp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports